
export class RefuelSms {
  id: number;

  assigned_on: string;

  creation_date: string;

  email_sent: boolean;

  language: string;

  mail: string;

  order_id: string;

  sms: number;

  user_id: number;

  uuid: string;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/refuelsms.entity.ts